<template>
  <div class="ProductInfo">
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane label="产品选择" >
        <span slot="label"><p class="el-icon-arrow-left back-icon" @click="back()"></p> 产品选择 </span>
        <div>
          <el-tabs tab-position="left" class="product-menu" v-model="selectedType">
            <el-tab-pane :label=type v-for="(type,i) in types" :key="i" :name="type">
              <div v-for="(s,j) in series" :key="j" style="float: left;width: 100%">
                <el-divider content-position="left" >{{s}}</el-divider>
                <div class="prolist-list" v-for="(product,k) in getProductArr(type,s)" :key="k">
                  <div class="prolist-div">
                    <div class="product-info">
                      <span>{{product}}</span>
                    </div>
                    <img :src="getImgUrl(product)" alt="" class="product-img" @click="handlePictureCardPreview(s,product)">
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <el-dialog
              :title="s_product.model"
              :visible.sync="dialogVisible"
              :modal-append-to-body='false'
              width="90%">
            <img :src="hqImgUrl" alt="" class="product-img-hq">
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="chooseProduct">选择此产品</el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
    import levelProduct from '@/assets/levelproduct.json'
    export default {
      name: "ProductInfo",
      data(){
        return{
          s_product: {type: '' , series: '' , model: '' , img: ''},   // 选择产品返回的参数
          types: [],    // 产品类型
          series: [],   // 产品系列
          selectedType:'',    // 选择的产品类型
          dialogVisible: false,   // 控制 el-dialog 显示隐藏的参数
          hqImgUrl: '',   // 高清图路径
          routeFrom: 'Index'    // 记录路由来源，便于返回
        }
      },
      created() {
        this.types = this.getTypeArr();
        this.selectedType = this.types[0];
      },
      mounted() {
        this.types = this.getTypeArr();
        this.selectedType = this.types[0];
      },
      beforeRouteEnter(to,from,next){
        // 记录路由来源，便于返回
        next(vm => {
          if(from.name) {
            vm.routeFrom = from.name;
          }
        })
      },
      watch: {
        // 监听选中的产品类型，获取对应的产品系列
        selectedType: {
          handler(){
            this.series = this.getSeriesArr(this.selectedType);
          }
        }
      },
      methods:{
        // 页面右上角 < 路由返回
        back(){
          this.$router.back();
        },
        // 获取图片地址，@/assets/propic/型号名.png
        getImgUrl(name){
          if(name.endsWith("系列")){
            name = name.slice(0,name.length-2);
          }
          return require('@/assets/propic/'+name+'.png');
        },
        // 获取高清图片地址，@/assets/HQ/型号名-HQ.png
        getHQImgUrl(name){
          if(name.endsWith("系列")){
            name = name.slice(0,name.length-2);
          }
          return require('@/assets/HQ/'+name+'-HQ.png');
        },
        //遍历json，返回产品类型数组
        getTypeArr() {
          let typeArr = [];
          levelProduct.forEach(function (item) {
            typeArr.push(item.name);
          });
          return typeArr;
        },
        //遍历json，返回产品系列数组
        getSeriesArr(type) {
          let seriesArr = [];
          levelProduct.forEach(function (item) {
            if (item.name === type) {
              item.series.forEach(function (args) {
                seriesArr.push(args.name);
              });
            }
          });
          return seriesArr;
        },
        //遍历json，返回产品型号数组
        getProductArr(type,series){
          let productArr = [];
          levelProduct.forEach(function(item){
            if (item.name === type){
              item.series.forEach(function (args) {
                if (args.name === series){
                  args.product.forEach(function (param) {
                    productArr.push(param);
                  })
                }
              });
            }
          });
          return productArr;
        },
        // 点击产品图片，预览打开，同时给s_product赋值
        handlePictureCardPreview(seriesName,productName){
          this.dialogVisible = true;
          this.hqImgUrl = this.getHQImgUrl(productName);
          this.s_product.type = this.selectedType;
          this.s_product.img = this.getImgUrl(productName);
          this.s_product.series = seriesName;
          this.s_product.model = productName;
        },
        // 选择产品，页面返回
        chooseProduct(){
          this.dialogVisible = false;
          if(this.s_product.model.endsWith("系列")){
            this.s_product.model = this.s_product.model.slice(0,this.s_product.model.length-2);
          }
          this.$router.push({
            name:this.routeFrom,
            params: {
              s_product: this.s_product
            }
          })
        }
      }
    }
</script>

<style scoped>
  .ProductInfo {
    height: 100%;
  }
  .ProductInfo > .el-tabs{
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  .prolist-list {
    margin: 0px 0px 10px 0px;
    float: left;
    font-size: 12px;
    color: #999;
  }
  .product-info {
    height: 28px;
    display:flex;
    justify-content:center;
    align-items:center;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane{
    height: 100%;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane > div{
    height: 100%;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane > div > .el-tabs{
    height: 100%;
  }
  .product-img-hq{
    width: 300px;
  }
</style>
<style>
  .ProductInfo .el-tabs__item {
    padding: 0px 10px!important;
  }
  .ProductInfo .el-tabs__content .el-tabs__content{
    height: 100%;
    overflow: scroll!important;
  }
  .ProductInfo > .el-tabs> .el-tabs__content {
    position: absolute!important;
    top: 40px;
    bottom: 0px;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane > div > .el-tabs > .el-tabs__header{
    height: 120px;
  }
  .ProductInfo .el-dialog__body {
    padding: 0px!important;
  }
  .ProductInfo .el-dialog__footer {
    text-align: center;
  }
</style>
